export default __webpack_public_path__ + "static/media/july2024-2.4f74a8f1.jpg";